<template>
  <v-container fluid>
    <attention-tool-set
        v-if="currentEvent"
        @change:events="events = $event" />
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2" class="pa-4">

        <v-row :class="['panel-layout-container', { dark: isDark }, {'pa-6 ma-4': !isMobile}]">

          <template  v-if="$route.meta && $route.meta.title">
            <v-col cols="12">
              <w-main-title
                  class="pb-0"
                  :title="$route.meta.title"
              ></w-main-title>
            </v-col>
          </template>

          <v-col cols="12">
            <router-view></router-view>
            <activation-blocker></activation-blocker>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ActivationBlocker from '@/components/account/ActivationBlocker'
import WMainTitle from "../components/common/WMainTitle.vue";
import AttentionToolSet from "../components/appointments/attention/toolset/AttentionToolSet.vue";
import {mapState} from 'vuex'
import UIMixin from "@/mixins/UIMixin";

export default {
  components: {
    ActivationBlocker,
    WMainTitle,
    AttentionToolSet,
  },
  mixins: [UIMixin],
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: true,
          href: ''
        },
      ]
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapState('clientAttention', {
      currentEvent: state => state.currentEvent,
      loadingEvent: state => state.loading
    }),
  },
  watch: {
    currentUser(val) {
      if (!val) {
        this.$router.replace({name: 'home'})
      }
    }
  }
}
</script>

<style scoped>
  .panel-layout-container{
    backdrop-filter: blur(10px);
    border-radius: 5px;
    background-color: rgba(255, 255, 255, .5);
  }

  .panel-layout-container.dark{
    background-color: rgba(0, 0, 0, .2);
  }
</style>
